// src/lang/index.js（简化版）
import Vue from 'vue'
import VueI18n from 'vue-i18n'

import ViewDesign from 'view-design';

import zh from 'view-design/src/locale/lang/zh-CN';
import zhArchives from './zh-CN/Archives.json'
import zhBigScreen from './zh-CN/BigScreen.json'
import zhCommon from './zh-CN/Common.json'
import zhLogin from './zh-CN/Login.json'
import zhMaintenance from './zh-CN/Maintenance.json'
import zhMember from './zh-CN/Member.json'
import zhOperationMonitoring from './zh-CN/OperationMonitoring.json'
import zhOrderMonitoring from './zh-CN/OrderMonitoring.json'
import zhStatisticalAnalysis from './zh-CN/StatisticalAnalysis.json'
import zhSysMonitoring from './zh-CN/SysMonitoring.json'
import zhTracking from './zh-CN/Tracking.json'
import zhMenu from './zh-CN/Menu.json'
import zhEnum from './zh-CN/Enum.json'
import zhModel from './zh-CN/Model.json'

import en from 'view-design/src/locale/lang/en-US';
import enArchives from './en-US/Archives.json'
import enBigScreen from './en-US/BigScreen.json'
import enCommon from './en-US/Common.json'
import enLogin from './en-US/Login.json'
import enMaintenance from './en-US/Maintenance.json'
import enMember from './en-US/Member.json'
import enOperationMonitoring from './en-US/OperationMonitoring.json'
import enOrderMonitoring from './en-US/OrderMonitoring.json'
import enStatisticalAnalysis from './en-US/StatisticalAnalysis.json'
import enSysMonitoring from './en-US/SysMonitoring.json'
import enTracking from './en-US/Tracking.json'
import enMenu from './en-US/Menu.json'
import enEnum from './en-US/Enum.json'
import enModel from './en-US/Model.json'

Vue.use(VueI18n)


const messages = {
  'zh-CN': {
    ...zh,
    ...zhArchives,
    ...zhBigScreen,
    ...zhCommon,
    ...zhLogin,
    ...zhMaintenance,
    ...zhMember,
    ...zhOperationMonitoring,
    ...zhOrderMonitoring,
    ...zhStatisticalAnalysis,
    ...zhSysMonitoring,
    ...zhTracking,
    ...zhMenu,
    ...zhEnum,
    ...zhModel
  },
  'en-US': {
    ...en,
    ...enArchives,
    ...enBigScreen,
    ...enCommon,
    ...enLogin,
    ...enMaintenance,
    ...enMember,
    ...enOperationMonitoring,
    ...enOrderMonitoring,
    ...enStatisticalAnalysis,
    ...enSysMonitoring,
    ...enTracking,
    ...enMenu,
    ...enEnum,
    ...enModel
  }
}

// 默认语言（优先本地存储，否则中文）
//const defaultLang = getStoredLang() || 'zh-CN';

const locale = localStorage.getItem('language') || 'en-US'
//const defaultLang = 'en-US';


export const i18n = new VueI18n({
  locale: locale,
  messages
})

// 同步 View Design 组件语言
ViewDesign.locale(i18n.getLocaleMessage(i18n.locale));

//console.log('简化后的i18n实例：', i18n)
//export default i18n